module.exports = __webpack_public_path__ + "h5/img/cs_12.94cfd6d9.jpeg";